import {get, identity, eq, pick, filter, isEqual } from 'lodash'

/**
 * Describes a server response item
 */
class Item {
    constructor(item) {
        Object.assign(this, item)
    }

    get code() {
        return getItemCode(this)
    }

    get name() {
        return getItemName(this)
    }
}

export function item(item) {
    return new Item(item)
}

/**
 * detect if name includes searchTerm. case insensitive
 * @param {string} name name of item
 * @param {string} searchTerm search term
 * @returns {boolean} true if match found, false otherwise
 */
function matchName(name, searchTerm) {
    return name.match(searchTerm)
}

/**
 * get normalized search term to use for matching with item name
 * @param {string} searchTerm
 * @returns {RegExp} match pattern
 */
function getSearchTerm(searchTerm) {
    return new RegExp(searchTerm, 'i')
}

/**
 * Get search term to use for matching with item name
 * @param {object} item - server response item
 * @returns {RegExp} match pattern
 */
export function getItemName(item) {
    return get(item, 'name') || get(item, 'NameInHebrew', '')
}

/**
 * Get item code value
 * @param {object} item - server response item
 * @returns {number}
 */
export function getItemCode(item) {
    return get(item, 'code') || get(item, 'Code')
}

export function getItemSelected(item) {
    return get(item, 'IsSelected')
}

export function getItemNumOfJobs(item) {
    return get(item, 'numOfJobs') || get(item, 'NumberOfJobs', 0)
}

export function getItemAreas(item) {
    return get(item, 'Areas') || get(item, 'areas')
}
export function getItemRegions(item) {
    return get(item, 'RegionIds') || get(item, 'regions')
}
export function getItemAreasOrRegions(item) {
    return getItemAreas(item) || getItemRegions(item)
}

/**
 * Generic transformer for matching 2 arguments ( i.e "match(a, b)"" )
 * @param {function} matcher - function to match between item and searchTerm arguments for [match] function
 * @param {function} itemFn - function to use on item argument in [match] function
 * @param {function} searchTermFn - function to use on searchTerm argument in [match] function
 * @returns {function} function with signature (item, searchTerm) => result
 */
function itemMatcher(matcher, itemFn, searchTermFn) {
    return function match(item, searchTerm) {
        return matcher(itemFn(item), searchTermFn(searchTerm))
    }
}

// /**
//  * Check if item equals to another item
//  * @param {object} itemToCheck - item to check
//  * @param {object} itemToCompare - item to compare
//  * @returns {boolean} true if item matches, false otherwise
//  */
// export const itemCodesEqual = itemMatcher(eq, getItemCode, getItemCode)

/**
 * Check if item includes searchTerm
 * @param {object} item - server response item
 * @param {string} searchTerm - search term
 * @returns {boolean} true if item matches, false otherwise
 */
export const itemIncludes = itemMatcher(matchName, getItemName, getSearchTerm)

/**
 * Check if item equals searchTerm
 * @param {object} item - server response item
 * @param {string} searchTerm - search term
 * @returns {boolean} true if items are equal, false otherwise
 */
export const itemEquals = itemMatcher(eq, getItemName, identity)

/**
 * Creates new object with 'Code' and 'NameInHebrew' props from existing object
 * @param {object} item - item
 * @returns {object} object with specific fields
 */
export function reduceObject(item) {
    return pick(item, ['Code', 'NameInHebrew', 'IsSelected', 'Regions', 'GeoLexId', 'Link'])
}

export function excludeItems(items = [], excludedItems = []) {
    return filter(items, item =>
        excludedItems.every(excludedItem => !isEqual(item, excludedItem))
    )
}